import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import './index.css';
import Aduke from './pages/Aduke';
import Contact from './pages/Contact';
import NewHome from './pages/NewHome';
import NotFound from './pages/NotFound';
import Portfolio from './pages/Portfolio';
import CaseStudy from './pages/Portfolio/CaseStudy';
import About from './pages/About';
import Stories from './pages/Stories';
import * as serviceWorker from './serviceWorker';
import BudgyApp from './products/Budgy';
import NestApp from './products/Nest';
import VelaApp from './products/Vela';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <NotFound />,
    children: [
      { index: true, element: <NewHome /> },
      { path: 'work', element: <Portfolio /> },
      { path: 'work/:slug', element: <CaseStudy /> },
      { path: 'portfolio', element: <Portfolio /> },
      { path: 'writing', element: <Stories /> },
      { path: 'contact', element: <Contact /> },
      { path: 'stories', element: <Stories /> },
      { path: 'about', element: <About /> },
      { path: 'aduke/*', element: <Aduke /> },
    ],
  },
  {
    path: '/budgy/*',
    element: <BudgyApp />,
  },
  {
    path: '/nest/*',
    element: <NestApp />,
  },
  {
    path: '/vela/*',
    element: <VelaApp />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RouterProvider router={router} />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
